import * as React from "react";

import { useCommonHooks } from "../../hooks";
import { HopeViewUserAvailability } from "../common/hopeView/userAvailability";

export const AvailabilityTab: React.FunctionComponent = () => {
  const { user } = useCommonHooks();

  return <HopeViewUserAvailability id={user?.userId} />;
};

export default AvailabilityTab;
